import React, {useContext, useEffect, useRef, useState} from "react";
import {Context} from "../../../App";
import DB_Orders from "../../../database/mobile/db_orders";
import {useTranslation} from "react-i18next";
import ModalWindow from "../../modal";
import {Outlet, useLocation, useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import {
    Breadcrumb,
    Button,
    Card,
    Col,
    DatePicker,
    Divider,
    Form,
    Input,
    Popconfirm,
    Row,
    Select,
    Space,
    Spin,
    Table,
    Typography,
} from "antd";
import moment from "moment";
import TagDocumentStatus from "./tag_status_order";
import {TradePointModel} from "../../../model/trade_point_model";
import BackButton from "../../tech/back_button";
import {DebounceSelect} from "../../tech/search_input";
import DB_TradePoint from "../../../database/dictionary/trade-point";
import DB_OrgStructure from "../../../database/dictionary/org_structures";
import DB_Branch from "../../../database/dictionary/branch";
import DB_Warehouse from "../../../database/dictionary/warehouse";
import DB_PayForms from "../../../database/dictionary/pay-forms";
import DB_PriceLists from "../../../database/dictionary/price-lists";
import EditableCell from "../../tech/editable_cell";
import Modal from "antd/es/modal/Modal";
import DB_OperationTypes from "../../../database/dictionary/operation_types";

const EditOrder = () => {
    const {order_id} = useParams()
    const {token, user, defaultPageSize, setToken} = useContext(Context)
    const {getOrder, updateOrder, updateOrderDetails} = DB_Orders(token)
    const {getTradePointFilter} = DB_TradePoint(token)
    const {getOrgStructureFilter} = DB_OrgStructure(token)
    const {getActiveBranches} = DB_Branch(token)
    const {getActiveWarehouses} = DB_Warehouse(token)
    const {filterPayForm} = DB_PayForms(token)
    const {branchesPriceLists} = DB_PriceLists(token)
    const {get} = DB_OperationTypes(token)
    const {t} = useTranslation()
    const {errorConnect} = ModalWindow()
    const navigate = useNavigate()
    const p = new URLSearchParams(window.location.search)
    const location = useLocation()
    const path = location.state == null ? null : (location.state.path == null ? null : location.state.path)
    const from = location.state == null ? null : (location.state.from == null ? null : location.state.from)
    const controller = new AbortController()
    const [wait, setWait] = useState(false)
    const [waitSpin, setWaitSpin] = useState(false)
    const [loadingFromBranch, setLoadingFromBranch] = useState(false)
    const [openDrawerTradePoint, setOpenDrawerTradePoint] = useState(false)
    const [form] = Form.useForm()
    const [formTable] = Form.useForm()
    const [branch, setBranch] = useState([])
    const [selectedBranch, setSelectedBranch] = useState()
    const [warehouses, setWarehouses] = useState([])
    const [payForms, setPayForms] = useState([])
    const [priceLists, setPriceLists] = useState([])
    const [operationTypes, setOperationTypes] = useState([])
    const [addPositions, setAddPositions] = useState(false)
    const [editingKey, setEditingKey] = useState('')
    const [updateDetails, setUpdateDetails] = useState(false)
    const [update, setUpdate] = useState(true)
    const isEditing = (record) => record.id === editingKey
    const [dateOrder, setDateOrder] = useState()
    const prevBranchRef = useRef()


    let [order, setOrder] = useState({
        date: order_id === 'new' ? moment() : null,
        date_order: null,
        org_structure: null,
        comment: null,
        comment_branch: null,
        order_status: 1,
        pay_form: null,
        price_list: null,
        sum_price: 0,
        sum_count: 0,
        sum_weight: 0,
        warehouse: null,
        operation_type: null
    })

    let [details, setDetails] = useState([])

    let [data, setData] = useState({
        order: order,
        trade_point: TradePointModel,
    })

    const edit = (record) => {
        if (record == null) { return }
        formTable.setFieldsValue({
            vendor_code_id: '',
            count: '',
            price: '',
            ...record,
        })
        setEditingKey(record.id);
    };



    const columns = [
        {
            title: "#",
            dataIndex: 'id',
            key: 'id',
        },
        {
            title: t('code'),
            dataIndex: 'vendor_code_id',
            editable: true,
        },
        {
            title: t('vendor_code'),
            dataIndex: 'vendor_code',
        },

        {
            title: t('count'),
            dataIndex: 'count',
            editable: true,
        },
        {
            title: t('price'),
            dataIndex: 'price',
            editable: true,
        },
        {
            title: '',
            dataIndex: 'operation',
            render: (_, record) => {
                const editable = isEditing(record);
                return editable ? (
                    <span>
            <Typography.Link
                onClick={() => save(record.id)}
                style={{
                    marginRight: 8,
                }}
            >
              {t('save')}
            </Typography.Link>
                        <Typography.Link
                            onClick={() => del(record.id)}
                            style={{
                                marginRight: 8,
                            }}
                        >
              {t('delete')}
            </Typography.Link>
            <Popconfirm title={t('q_sure_cancel')} onConfirm={cancel}>
              <a>{t('cancel')}</a>
            </Popconfirm>
          </span>
                ) : (
                    <Typography.Link disabled={editingKey !== ''} onClick={() => edit(record)}>
                        {t('edit')}
                    </Typography.Link>
                );
            },
        },
    ]

    useEffect(() => {
        window.scroll(0, 0)
        if (wait) {
            controller.abort()
        }
        if (order_id != null && order_id !== 'new') {
            setWait(true)
            getOrder(controller, order_id)
                .then(res => {
                    setData(res.data)
                    setDetails(res.data.details)
                    setSelectedBranch(res.data.order.branch_id)
                    setDateOrder(moment(res.data.order.date_order, "YYYY-MM-DD"))
                    form.setFieldsValue({
                            org_structure: {
                                key: res.data.order.org_structure_id,
                                label: res.data.order.org_structure,
                                value: res.data.order.org_structure_id
                            },
                            trade_point: {
                                key: res.data.trade_point.id,
                                label: res.data.trade_point.name,
                                value: res.data.trade_point.id
                            },
                            branch: res.data.order.branch_id,
                            warehouse: res.data.order.warehouse_id,
                            price_list: res.data.order.price_list_id,
                            pay_form: res.data.order.pay_form_id,
                            operation_type: res.data.order.operation_type_id,
                            date_order: moment(res.data.order.date_order, "YYYY-MM-DD"),
                            comment: res.data.order.comment
                        }
                    )
                    setWait(false);
                })
                .catch((e) => {
                    if (!axios.isCancel(e)) {
                        if (e.request.status === 403) {
                            setToken(null)
                        } else {
                            setWait(false)
                            errorConnect()
                        }
                    }
                })
        }
    }, [])


    useEffect(() => {
        if (order_id === 'new') {
            setWaitSpin(false)
            setUpdateDetails(false)
            setEditingKey('');
            return
        }

        if (updateDetails) {
            setWaitSpin(true)

            updateOrderDetails(order_id, details)
                .then(res => {
                    if (res.request.status === 200) {
                        setDetails(res.data)
                        setUpdate(!update)
                    }
                })
                .catch(e => {
                    if (e.response.status === 400) {
                        Modal.error({
                            title: t('error'),
                            content: t('vendor_code_not_find'),
                        })
                    } else {
                        errorConnect()
                    }
                })
                .finally(() => {
                        setWaitSpin(false)
                        setUpdateDetails(false)
                        setEditingKey('');
                    }
                )
        }
    }, [updateDetails])

    useEffect(() => {
        axios.all([getActiveBranches()])
            .then(axios.spread((branch) => {
                setBranch(branch.data)
            }))
            .catch(e => {
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    errorConnect()
                }
            })
    }, [])

    useEffect(() => {
        setLoadingFromBranch(true)
        if (prevBranchRef.current !== undefined) {
            form.setFieldsValue({
                    warehouse: null,
                    pay_form: null,
                    price_list: null
                }
            )
        }

        axios.all([
            getActiveWarehouses(selectedBranch),
            filterPayForm(selectedBranch),
            branchesPriceLists(selectedBranch),
            get(new AbortController(), {active: true})
        ])
            .then(axios.spread((warehouses, payForms, priceLists, operationTypes) => {
                setWarehouses(warehouses.data)
                setPayForms(payForms.data)
                setPriceLists(priceLists.data)
                setOperationTypes(operationTypes.data.data)
                setLoadingFromBranch(false)
            }))
            .catch(e => {
                setLoadingFromBranch(false)
                if (e.request.status === 403) {
                    setToken(null)
                } else {
                    errorConnect()
                }
            })
        prevBranchRef.current = selectedBranch;
    }, [selectedBranch])


    const handleAdd = () => {
        const newData = {
            id: details.length + 1,
            vendor_code_id: '',
            vendor_code: '',
            count: '',
            price: ''
        };
        setAddPositions(true)
        setDetails([...details, newData])
    }

    const cancel = () => {
        setEditingKey('')
        if (addPositions) {
            setDetails(details.slice(0, details.length - 1))
            setAddPositions(false)
        }
    }

    const save = async (key) => {
        try {
            const row = await formTable.validateFields();
            const newData = [...details];
            const index = newData.findIndex((item) => key === item.id);
            if (index > -1) {
                const item = newData[index];
                newData.splice(index, 1, {
                    ...item,
                    ...row,
                });
            } else {
                newData.push(row);
            }
            setUpdateDetails(true)
            setDetails(newData)
            setAddPositions(false)
        } catch (errInfo) {
            console.log('Validate Failed:', errInfo);
        }
    };

    const del = (id) => {
        setUpdateDetails(true)
        setDetails(details.filter(i => i.id !== id))
    }

    useEffect(() => {
        if (addPositions) {
            edit(details[details.length - 1])
        }
    }, [details])

    const saveOrder = (values) => {
        setWait(true)

        let data = {
            order: {
                order_id: order_id,
                date_order: form.getFieldValue('date_order').format("YYYY-MM-DD"),
                trade_point_code: form.getFieldValue('trade_point').value,
                org_structure_id: form.getFieldValue('org_structure').value,
                pay_form_id: form.getFieldValue('pay_form'),
                price_list_id: form.getFieldValue('price_list'),
                operation_type_id: form.getFieldValue('operation_type'),
                branch_id: form.getFieldValue('branch'),
                warehouse_id: form.getFieldValue('warehouse'),
                comment: form.getFieldValue('comment')
            }
        }

        if (order_id === 'new') {
            data['details'] = details
        }
        updateOrder(order_id, data)
            .then(res => {
                if (res.request.status === 200) {
                    window.history.back()
                }
            })
            .catch(e => {
                if (e.response.status === 403) {
                    setToken(null)
                }
                errorConnect()
            })
            .finally(() => {
                setWait(false)
                // setAddPositions(false)
            })
    }

    const mergedColumns = columns.map((col) => {
        if (!col.editable) {
            return col;
        }
        return {
            ...col,
            onCell: (record) => {
                return({
                    record,
                    inputType: col.dataIndex === 'vendor_code_id'
                    || col.dataIndex === 'vendor_code'
                    || col.dataIndex === 'count'
                    || col.dataIndex === 'price'
                        ? 'number' : 'text',
                    dataIndex: col.dataIndex,
                    title: col.title,
                    editing: isEditing(record),
                })},
        };
    });


    return (
        <>
            <Spin spinning={wait} delay={300}>
                <div className="page">
                    <Space
                        style={{
                            width: '100%',
                            justifyContent: 'space-between'
                        }}>
                        <Breadcrumb
                            style={{
                                margin: '15pt 0',
                            }}
                        >
                            <Breadcrumb.Item>
                            <span className={'ant-page-header-heading-title'} style={{paddingLeft:'24px'}}>
                                {t('order')}</span>
                            </Breadcrumb.Item>
                        </Breadcrumb>

                        <Space>
                            <BackButton/>
                            <Button type={'primary'} shape={'round'} htmlType="submit" form={"form"}>
                                {t('save')}
                            </Button>
                        </Space>
                    </Space>
                    <Card
                        title={<>{t('order_id')} <br/> {data.order.id}</>} extra={<TagDocumentStatus record={order}/>}
                    >
                        {/*<Skeleton loading={wait} active>*/}
                        <Form
                            form={form}
                            name="advanced_search"
                            className="ant-advanced-search-form"
                            layout={"horizontal"}
                            onFinish={saveOrder}
                            id={"form"}
                        >

                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item
                                        name='date_order'
                                        label={t('date_order')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('e_select', {select: t('date_order').toLowerCase()}),
                                            },
                                        ]}
                                    >
                                        <DatePicker
                                            defaultValue={dateOrder}
                                            value={dateOrder}
                                            // onChange={e => filterDate(e)}
                                            format={'DD.MM.YYYY'}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item
                                        name='branch'
                                        label={t('branch')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('e_select', {select: t('branch').toLowerCase()}),
                                            },
                                        ]}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="name"
                                            optionLabelProp="name"
                                            onSelect={e => setSelectedBranch(e)}>
                                            {
                                                branch.map(b =>
                                                    <Select.Option key={b.id} value={b.id} name={b.name}>{b.name}</Select.Option>
                                                )
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        name='warehouse'
                                        label={t('warehouse')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('e_select', {select: t('warehouse').toLowerCase()}),
                                            },
                                        ]}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="name"
                                            optionLabelProp="name"
                                            disabled={selectedBranch == null }
                                            loading={loadingFromBranch}>
                                            {
                                                warehouses.map(w =>
                                                    <Select.Option key={w.id} value={w.id}
                                                                   name={w.name}>{w.name}</Select.Option>
                                                )
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>

                            </Row>

                            <Row gutter={24}>
                                <Col span={8}>
                                    <Form.Item
                                        name='pay_form'
                                        label={t('pay_form')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('e_select', {select: t('pay_form').toLowerCase()}),
                                            },
                                        ]}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="name"
                                            optionLabelProp="name"
                                            disabled={selectedBranch == null }
                                            loading={loadingFromBranch}>
                                            {
                                                payForms.map(w =>
                                                    <Select.Option key={w.id} value={w.id}
                                                                   name={w.name}>{w.name}</Select.Option>
                                                )
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>

                                <Col span={8}>
                                    <Form.Item
                                        name='price_list'
                                        label={t('price_list')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('e_select', {select: t('price_list').toLowerCase()}),
                                            },
                                        ]}
                                    >
                                        <Select
                                            showSearch
                                            optionFilterProp="name"
                                            optionLabelProp="name"
                                            disabled={selectedBranch == null }
                                            loading={loadingFromBranch}>
                                            {
                                                priceLists.map(w =>
                                                    <Select.Option key={w.id} value={w.id}
                                                                   name={w.name}>{w.name}</Select.Option>
                                                )
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={8}>
                                <Col span={8}>
                                    <Form.Item
                                        name='operation_type'
                                        label={t('operation_type')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('e_select', {select: t('operation_type').toLowerCase()}),
                                            },
                                        ]}
                                    >
                                        <Select
                                            optionFilterProp="name"
                                            optionLabelProp="name">
                                            {
                                                operationTypes.map(w =>
                                                    <Select.Option key={w.id} value={w.id}
                                                                   name={w.name}>{w.name}</Select.Option>
                                                )
                                            }
                                        </Select>
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={16}>
                                    <Form.Item
                                        name='trade_point'
                                        label={t('trade_point')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('e_select', {select: t('trade_point').toLowerCase()}),
                                            },
                                        ]}
                                    >
                                        <DebounceSelect
                                            // mode="multiple"
                                            showSearch
                                            fetchOptions={getTradePointFilter}
                                            branch={24}
                                        />
                                    </Form.Item>
                                </Col>
                            </Row>

                            <Row gutter={24}>
                                <Col span={16}>
                                    <Form.Item
                                        name='org_structure'
                                        label={t('org_structure_s')}
                                        rules={[
                                            {
                                                required: true,
                                                message: t('e_select', {select: t('org_structure_s').toLowerCase()}),
                                            },
                                        ]}
                                    >
                                        <DebounceSelect
                                            // mode="multiple"
                                            showSearch
                                            fetchOptions={getOrgStructureFilter}
                                        />
                                    </Form.Item>
                                </Col>

                            </Row>

                            <Row gutter={24}>
                                <Col span={16}>
                                    <Form.Item
                                        name='comment'
                                        label={t('comment')}
                                    >
                                        <Input.TextArea showCount maxLength={300} style={{
                                            height: 120,
                                        }}/>
                                    </Form.Item>
                                </Col>
                            </Row>
                        </Form>
                        {/*</Skeleton>*/}
                        <Divider/>

                        <div style={{marginBottom: '10pt', display: 'flex', justifyContent: 'end'}}>
                            <Button onClick={handleAdd}>{t('add')}</Button>
                        </div>
                        <Form form={formTable} component={false}>
                            <Table
                                style={{'--cursor': "auto" }}
                                columns={mergedColumns}
                                dataSource={details}
                                rowKey="id"
                                loading={waitSpin}
                                pagination={false}
                                size={"small"}
                                components={{
                                    body: {
                                        cell: EditableCell,
                                    },
                                }}
                            />
                        </Form>
                    </Card>
                </div>
                <Outlet/>

                {/*<DrawerTradePoint*/}
                {/*    trade_point={data.trade_point}*/}
                {/*    show={openDrawerTradePoint}*/}
                {/*    setShow={setOpenDrawerTradePoint}/>*/}
            </Spin>
        </>
    )
}

export default EditOrder